import { useMemo } from 'react';
var useMemoOnce = function (factory) { return useMemo(factory, []); };
export default useMemoOnce;
//# sourceMappingURL=useMemoOnce.js.map